import { router } from '@inertiajs/svelte'
import { CONNECTION_ERROR_MESSAGE } from 'frontend/inertia/errors'
import { show as showSnackbar } from 'shared/javascripts/components/snackbar.svelte'

// Returning false takes over Inertia's default, which re-rejects into an unhandled rejection.
export function reportInertiaNetworkErrors(): () => void {
  return router.on('networkError', (event) => {
    if (!isConnectionFailure(event.detail.error)) {
      return
    }

    showSnackbar({ message: CONNECTION_ERROR_MESSAGE, type: 'error' })
    return false
  })
}

// The event also carries errors thrown by application callbacks, so match Inertia's own
// `HttpNetworkError` — by `code`, to avoid a runtime `@inertiajs/core` import.
function isConnectionFailure(error: unknown): boolean {
  return error instanceof Error && (error as { code?: unknown }).code === 'ERR_NETWORK'
}
